import { render, staticRenderFns } from "./oidc-callback.vue?vue&type=template&id=563f347c&"
import script from "./oidc-callback.vue?vue&type=script&lang=js&"
export * from "./oidc-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports